import React, { useState } from 'react';
import {
  Button,
  Container,
  TextField,
  Table,
  Modal,
  TableBody,
  TableCell,
  Box,
  Typography,
  TableContainer,
  IconButton,
  TableHead,
  TableRow,
  Paper,
  styled,
  InputAdornment,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  useTheme,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ExpenseGroup = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal, setShowUserGuideModal] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddExpenseGroupModal, setShowAddExpenseGroupModal] = useState(false);
  const [showEditExpenseGroupModal, setShowEditExpenseGroupModal] = useState(false);
  const [selectedExpenseGroup, setSelectedExpenseGroup] = useState({ expenseGroupId: null, expenseGroupName: '' });
  const [formData, setFormData] = useState({
    expenseGroup: '',
    remark: '',
    taxType: '5%',
  });

  // Static data for expense groups
  const staticExpenseGroupData = [
    { expenseGroupId: 1, expenseGroupName: 'Travel', remark: 'All travel-related expenses', taxType: '5%' },
    { expenseGroupId: 2, expenseGroupName: 'Office Supplies', remark: 'Expenses for office supplies', taxType: 'zero-rated' },
    { expenseGroupId: 3, expenseGroupName: 'Utilities', remark: 'Utility bills and expenses', taxType: 'exempted' },
    { expenseGroupId: 4, expenseGroupName: 'Salaries', remark: 'Employee salaries and wages', taxType: '5%' },
    { expenseGroupId: 5, expenseGroupName: 'Marketing', remark: 'Marketing and advertising expenses', taxType: 'zero-rated' },
    { expenseGroupId: 6, expenseGroupName: 'Miscellaneous', remark: 'Miscellaneous expenses', taxType: 'exempted' },
  ];

  const handleAddExpenseGroup = () => {
    setFormData({
      expenseGroup: '',
      remark: '',
      taxType: '5%',
    });
    setShowAddExpenseGroupModal(true);
  };

  const handleEdit = (expenseGroup) => {
    setSelectedExpenseGroup({ expenseGroupId: expenseGroup.expenseGroupId, expenseGroupName: expenseGroup.expenseGroupName });
    setFormData({
      expenseGroup: expenseGroup.expenseGroupName,
      remark: expenseGroup.remark,
      taxType: expenseGroup.taxType,
    });
    setShowEditExpenseGroupModal(true);
  };

  const handleDelete = (expenseGroupId, expenseGroupName) => {
    setSelectedExpenseGroup({ expenseGroupId, expenseGroupName });
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
     setSnackbarMessage('Deleted successfully!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("success");
    setShowDeleteModal(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (!formData.expenseGroup || !formData.remark) {
      alert('Please fill all fields');
      return;
    }
    setSnackbarMessage('Expense Group Added Successfully');
    setOpenSnackbar(true);
    setSnackbarSeverity('success')
    setShowAddExpenseGroupModal(false);
    setFormData({
      expenseGroup: '',
      remark: '',
      taxType: '5%',
    });
  };

  const handleUpdate = () => {
    if (!formData.expenseGroup || !formData.remark) {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("success");
      return;
    }
    setSnackbarMessage('Expense Group Updated Successfully');
    setOpenSnackbar(true);
    setSnackbarSeverity('success')
    setShowEditExpenseGroupModal(false);
  };

  const handleReset = () => {
    setFormData({
      expenseGroup: '',
      remark: '',
      taxType: '5%',
    });
  };

  const handleCancel = () => {
    setShowEditExpenseGroupModal(false);
  };

  const filteredData = staticExpenseGroupData.filter((expenseGroup) =>
    expenseGroup.expenseGroupName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    expenseGroup.remark.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, p: 2, boxShadow: 'none', maxWidth: '100%', boxSizing: 'border-box' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
         <TextField
                                    variant="outlined"
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <SearchIcon
                                            sx={{
                                              color: theme.palette.primary.main,
                                              marginLeft: 1.5,
                                              fontSize: 24,
                                            }}
                                          />
                                        </InputAdornment>
                                      ),
                                      endAdornment: searchTerm && (
                                        <InputAdornment position="end">
                                          <IconButton
                                            size="small"
                                            onClick={() => setSearchTerm('')}
                                            sx={{
                                              color: "grey",
                                              marginRight: 1,
                                            }}
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        </InputAdornment>
                                      ),
                                      sx: {
                                        borderRadius: '30px',
                                        backgroundColor: theme.palette.mode === 'dark'
                                          ? 'rgba(255, 255, 255, 0.15)'
                                          : 'rgba(255, 255, 255, 1)',
                                        boxShadow: theme.palette.mode === 'dark'
                                          ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                          : '0 2px 8px rgba(0, 0, 0, 0.1)',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                          border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                                        },
                                        '&:hover': {
                                          backgroundColor: theme.palette.mode === 'dark'
                                            ? 'rgba(255, 255, 255, 0.2)'
                                            : 'rgba(240, 240, 240, 1)',
                                          boxShadow: theme.palette.mode === 'dark'
                                            ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                            : '0 2px 12px rgba(0, 0, 0, 0.15)',
                                        },
                                        '&.Mui-focused': {
                                          backgroundColor: theme.palette.mode === 'dark'
                                            ? 'rgba(255, 255, 255, 0.25)'
                                            : 'rgba(255, 255, 255, 1)',
                                          boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                          '& .MuiOutlinedInput-notchedOutline': {
                                            border: `2px solid ${theme.palette.primary.main}`,
                                          },
                                        },
                                        paddingLeft: 1.5,
                                        height: '50px',
                                        transition: 'all 0.3s ease',
                                      },
                                    }}
                                    sx={{
                                      width: 350,
                                      maxWidth: '100%',
                                      '& .MuiInputBase-input': {
                                        padding: '10px 14px',
                                        color: theme.palette.text.primary,
                                        fontWeight: 500,
                                      },
                                    }}
                                  />
          <Button
            variant="contained"
            onClick={handleAddExpenseGroup}
            sx={{
              ml: 2,
              width: "100px",
              height: "50px",
              borderRadius: "10px",
              padding: "10px 0",
              fontWeight: 'bold',
              backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.dark },
            }}
            startIcon={<AddIcon />}
          >
            ADD
          </Button>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={() => setShowUserGuideModal(true)}
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              minWidth: 0, // Remove MUI's default padding
            }}
          >
            <InfoOutlineIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Box>
      </Box>
      <Paper elevation={3} sx={{ paddingBottom: 0, maxWidth: '100%', boxSizing: 'border-box', mx: 'auto', backgroundColor: theme.palette.background.paper, borderRadius: '16px' }}>
        <Box sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Expense Group</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Remark</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Tax Type</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem' }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((expenseGroup, index) => (
                    <TableRow
                      key={expenseGroup.expenseGroupId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{expenseGroup.expenseGroupName}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{expenseGroup.remark}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{expenseGroup.taxType}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() => handleEdit(expenseGroup)}
                          sx={{
                            color: theme.palette.primary.light,
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(expenseGroup.expenseGroupId, expenseGroup.expenseGroupName)}
                          sx={{
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow
                    sx={{
                      backgroundColor: theme.palette.background.paper,
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <TableCell colSpan={5} align="center" sx={{ fontSize: '1rem', padding: '20px' }}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>
      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography
            variant="body2"
            color={theme.palette.primary.main}
          >
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Modal open={showDeleteModal} onClose={handleCloseDeleteModal} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete {selectedExpenseGroup.expenseGroupName}?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleCloseDeleteModal}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={showAddExpenseGroupModal} onClose={() => setShowAddExpenseGroupModal(false)} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Expense Group
            </Typography>
            <IconButton onClick={() => setShowAddExpenseGroupModal(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Expense Group"
                variant="outlined"
                fullWidth
                name="expenseGroup"
                value={formData.expenseGroup}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Remark"
                variant="outlined"
                fullWidth
                name="remark"
                value={formData.remark}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl component="fieldset">
                <Typography component="legend" sx={{ color: theme.palette.text.primary }}>Tax Type</Typography>
                <RadioGroup row aria-label="taxType" name="taxType" value={formData.taxType} onChange={handleChange}>
                  <FormControlLabel value="5%" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="5%" />
                  <FormControlLabel value="zero-rated" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="Zero-rated" />
                  <FormControlLabel value="exempted" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="Exempted" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip
                title={
                  !formData.expenseGroup ? 'Enter Expense Group' :
                    !formData.remark ? 'Enter Remark' : ''
                }
                arrow
              >
                <Button
                  variant="contained"
                  onClick={handleSave}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={!formData.expenseGroup || !formData.remark}
                >
                  SAVE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={showEditExpenseGroupModal} onClose={handleCancel} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Expense Group
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Expense Group"
                variant="outlined"
                fullWidth
                name="expenseGroup"
                value={formData.expenseGroup}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Remark"
                variant="outlined"
                fullWidth
                name="remark"
                value={formData.remark}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl component="fieldset">
                <Typography component="legend" sx={{ color: theme.palette.text.primary }}>Tax Type</Typography>
                <RadioGroup row aria-label="taxType" name="taxType" value={formData.taxType} onChange={handleChange}>
                  <FormControlLabel value="5%" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="5%" />
                  <FormControlLabel value="zero-rated" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="Zero-rated" />
                  <FormControlLabel value="exempted" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="Exempted" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip
                title={
                  !formData.expenseGroup ? 'Enter Expense Group' :
                    !formData.remark ? 'Enter Remark' : ''
                }
                arrow
              >
                <Button
                  variant="contained"
                  onClick={handleUpdate}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={!formData.expenseGroup || !formData.remark}
                >
                  UPDATE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
      open={showUserGuideModal}
      onClose={() => setShowUserGuideModal(false)}
      BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          borderRadius: '16px',
          boxShadow: 24,
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: '12px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
            Expense Group Management - User Guide
          </Typography>
          <IconButton
            onClick={() => setShowUserGuideModal(false)}
            sx={{ color: '#fff', position: 'absolute', right: 14 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Scrollable Content */}
        <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
          {/* Section 1: Search Expense Groups */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
          >
            ➤ Follow these steps to search for expense groups:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              In the search bar at the top left, enter a name related to the expense group name or remark.
            </li>
            <li>
              The table will automatically filter to display only the groups matching the search term.
            </li>
            <li>
              Clear the search bar to view all expense groups again.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The search is case-insensitive and matches partial text in the expense group name or remark fields.
          </Typography>

          {/* Section 2: Add an Expense Group */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to add an expense group:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              Click the <strong>"ADD"</strong> button at the top left to open the Add Expense Group modal.
            </li>
            <li>
              Enter the <strong>Expense Group</strong> name and <strong>Remark</strong> in the provided fields, and select a <strong>Tax Type</strong> (5%, Zero-rated, or Exempted). Expense Group and Remark are required, while Tax Type defaults to 5% if not changed.
            </li>
            <li>Before clicking on <strong>"SAVE"</strong> button, ensure all required fields are filled out correctly.</li>
            <li>
              Then click the <strong>"SAVE"</strong> button to add the group.
            </li>
            <li>
              If Expense Group or Remark is missing, an alert message will display to you to fill all required fields.
            </li>
            <li>
              Upon successful addition, a success message will appear, and the modal will close.
            </li>
            <li>
              If you want to reset the form, click the <strong>"RESET"</strong> button to clear all form fields and reset Tax Type to 5% if needed.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Expense Group and Remark are required to save an expense group. Tax Type is optional and defaults to 5%.
          </Typography>

          {/* Section 3: Edit an Expense Group */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to update an expense group:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              In the expense groups table, select the group whose details you want to edit/update.
            </li>
            <li>
              Click the <strong>Edit</strong> icon (pencil) in the Action column for the desired group.
            </li>
            <li>
              The Edit Expense Group modal will open, with the form pre-populated with the group’s details.
            </li>
            <li>
              You can update the necessary fields a/c to Your requirements: <strong>Expense Group</strong>, <strong>Remark</strong>, and <strong>Tax Type</strong> (5%, Zero-rated, or Exempted). Expense Group and Remark are required.
            </li>
            <li>
              Click the <strong>"UPDATE"</strong> button to save changes.
            </li>
            <li>
              If Expense Group or Remark is missing, an alert  message will prompt or display to you for filling  required fields.
            </li>
            <li>
              If you want to cancel then click on <strong>"CANCEL"</strong> button to discard changes and close the modal.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Expense Group and Remark are required to update an expense group. Tax Type can be updated as needed.
          </Typography>

          {/* Section 4: Delete an Expense Group */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to delete an expense group:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              In the expense groups table, select the group whose details you want to delete.
            </li>
            <li>
              Then click the <strong>Delete</strong> icon  in the Action column for the desired group.
            </li>
            <li>
              A confirmation modal will appear, asking you to confirm the deletion.
            </li>
            <li>
              Click <strong>"Yes, Delete"</strong> to remove the group, or <strong>"Cancel"</strong> to close the modal without deleting.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Deleting an expense group is permanent and cannot be undone.
          </Typography>

          {/* Section 5: Navigate the Expense Groups List */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to navigate the expense groups list:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              Use the pagination controls at the bottom to navigate through pages of expense groups.
            </li>
            <li>
              Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
            </li>
            <li>
              Select a specific page number by clicking on it.
            </li>
            <li>
              Adjust the number of rows per page using the dropdown menu (e.g., 5, 10, 20, 30 rows).
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The table displays only the selected number of rows per page. If no groups match the search term, "No Data Found" will be displayed.
          </Typography>

          {/* Bottom Close Button */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            {/* <Button
              variant="contained"
              onClick={() => setShowUserGuideModal(false)}
              sx={{
                backgroundColor: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.primary.dark },
                fontWeight: 'bold',
                padding: '8px 24px',
                borderRadius: '8px',
              }}
            >
              Close
            </Button> */}
          </Box>
        </CustomTableScrollbar>
      </Box>
    </Modal>
    <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default ExpenseGroup;